import React from 'react';
import {Box, Tab, Tabs} from '@mui/material';
import {useLocalization} from 'localization';
import {NorafChangesList} from './NorafChangesList';
import {NorafIgnoredList} from './NorafIgnoredList';
import {NorafTabPanel} from './NorafTabPanel';

function a11yProps(index: number) {
  return {
    id: `noraf-tab-${index}`,
    'aria-controls': `noraf-tabpanel-${index}`,
  };
}

export default function NorafTabs() {
  const [tab, setTab] = React.useState(0);
  const {t} = useLocalization();

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{width: '100%'}}>
      <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
        <Tabs value={tab} onChange={handleTabChange} aria-label="noraf tabs">
          <Tab
            label={t('page.agents.noraf.changes.shortTitle')}
            {...a11yProps(0)}
          />
          <Tab
            label={t('page.agents.noraf.ignores.shortTitle')}
            {...a11yProps(1)}
          />
        </Tabs>
      </Box>
      <NorafTabPanel value={tab} index={0}>
        <NorafChangesList />
      </NorafTabPanel>
      <NorafTabPanel value={tab} index={1}>
        <NorafIgnoredList />
      </NorafTabPanel>
    </Box>
  );
}
